<template lang="pug">
  #mental-wellness-workshops
    .companion-action-menu
        CompanionActionsMenu(:backButton="goBack")
    div(v-for="(workshop, index) in workshops" :key="index")
        PreviewCard(
        :moduleType="'workshop'" 
        :moduleIcon="'companion/workshop_icon'" 
        :id="workshop.Id" 
        :redirectTo="{ name: 'CompanionWorkshop' , params:{ workshopId: workshop.Id}}"
        :backgroundColor="'#' + workshop.BackgroundColor" 
        :previewImage="workshop.HeroImage" 
        :duration="workshop.Length" 
        :title="workshop.Title" 
        :tag="workshop.StartDate"
        )
            
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import PreviewCard from "@@/Companion/PreviewCard";
import { mapActions } from "vuex";

export default {
  name: "WorkshopViewAll",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    PreviewCard,
    CompanionActionsMenu
  },
  props: {
    workshops: { type: Array, required: true }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions(["snackBar"]),
    goBack() {
      window.history.back();
    }
  }
};
</script>
<style scoped>
#mental-wellness-workshops {
  width: 100% !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column !important;
  gap: 24px !important;
}
</style>
